import { Injectable } from '@angular/core';
import { AuthApiConstant } from '../constants/parmed-api.constant';
import { BaseApi } from './base-api';
import {
  AppConfigService as AppConfig,
  Configuration
} from '../services/init/app-config.service';

@Injectable()
export class AuthApi extends BaseApi {
  /******************Properties******************/
  readonly VALIDATE_CAPTCHA_URL: string = AuthApiConstant.VALIDATE_CAPTCHA;
  readonly VERIFY_TOKEN_URL: string = AuthApiConstant.VERIFY_TOKEN;
  readonly VERIFY_SECURITY_ANSWER_URL: string =
    AuthApiConstant.VERIFY_SECURITY_ANSWER;
  readonly ACTIVATE_USER_URL: string = AuthApiConstant.ACTIVATE_USER;
  readonly FORGOT_PASSWORD_URL: string = AuthApiConstant.FORGOT_AUTH;
  readonly RESET_PASSWORD_URL: string = AuthApiConstant.RESET_AUTH;
  readonly GET_SECURITY_QUESTIONS_URL: string =
    AuthApiConstant.GET_SECURITY_QUESTIONS;
  readonly CHANGE_PASSWORD_URL: string = AuthApiConstant.CHANGE_AUTH;
  readonly UPDATE_SECURITY_QUESTION_URL: string =
    AuthApiConstant.UPDATE_SECURITY_QUESTION;
  readonly UNLOCK_ACCOUNT_URL: string = AuthApiConstant.UNLOCK_ACCOUNT;
  readonly REGISTER_USER_URL: string = AuthApiConstant.REGISTER_USER;
  readonly GET_VERIFY_TOKEN_URL: string = AuthApiConstant.GET_VERIFY_TOKEN;
  readonly SESSION_CREATE_URL: string = AuthApiConstant.OKTA_SESSION_CREATE;
  readonly SESSION_VALIDATE_URL: string = AuthApiConstant.OKTA_SESSION_VALIDATE;
  readonly SESSION_CLEAR_URL: string = AuthApiConstant.OKTA_SESSION_CLEAR;
  readonly REGISTER_MIGRATE_USER_URL: string =
    AuthApiConstant.REGISTER_MIGRATE_USER;
    readonly CHECK_DUPLICATE_EMAIL_URL: string = AuthApiConstant.CHECK_DUPLICATE_EMAIL;
  /******************Properties******************/

  /***************Constructor***************/
  constructor(config: AppConfig) {
    super(config, Configuration.AUTH_API_ENDPOINT);
    this.reset(this);
  }
  /***************Constructor***************/
}
